/*eslint-disable*/
import Hammer from 'hammerjs'
import svgPanZoom from 'svg-pan-zoom'
import _ from 'lodash'

export default {
    methods: {
        createMap () {
            if (window.innerWidth > window.innerHeight) {
                let vm = this;
                let mapElement = document.getElementById('map');
                if (!mapElement) {
                    return;
                }
                this.map = svgPanZoom('#map', {
                    viewportSelector: '.svg-pan-zoom_viewport',
                    panEnabled: true,
                    controlIconsEnabled: false,
                    zoomEnabled: true,
                    dblClickZoomEnabled: true,
                    mouseWheelZoomEnabled: true,
                    preventMouseEventsDefault: true,
                    zoomScaleSensitivity: 0.15,
                    minZoom: 1.4,
                    maxZoom: 2.5,
                    fit: true,
                    contain: false,
                    center: false,
                    refreshRate: 'auto',
                    eventsListenerElement: null,
                    customEventsHandler: {
                        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
                        init: function (options) {
                            let instance = options.instance;
                            let initialScale = 1;
                            let pannedX = 0;
                            let pannedY = 0;
                            this.hammer = Hammer(document.getElementById('map-wrapper'), {
                                inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
                            });
                            this.hammer.get('pinch').set({enable: true});
                            this.hammer.on('panstart panmove', _.throttle((ev) => {
                                if (!vm.isPanEnabled) {
                                    return;
                                }
                                vm.disableEvents();
                                if (ev.type === 'panstart') {
                                    pannedX = 0;
                                    pannedY = 0;
                                }
                                instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY});
                                pannedX = ev.deltaX;
                                pannedY = ev.deltaY;
                            }, 50, {trailing: false}));
                            this.hammer.on('pinchstart pinchmove', (ev) => {
                                if (ev.type === 'pinchstart') {
                                    initialScale = instance.getZoom();
                                    instance.zoom(initialScale * ev.scale);
                                }
                                instance.zoom(initialScale * ev.scale);
                            });
                            this.hammer.on('panend', vm.limitPan);
                            options.svgElement.addEventListener('touchmove', (e) => {
                                e.preventDefault();
                            });
                        },
                        destroy: function () {
                            this.hammer.destroy();
                        }
                    },
                    beforePan: function (oldPan, newPan) {
                        if (vm.disablePanEvents) {
                            return newPan;
                        }
                        let sizes = this.getSizes();
                        let svg = document.querySelector('.svg-pan-zoom_viewport');
                        if (!svg) {
                            return newPan;
                        }
                        let clientRect = svg.getBoundingClientRect();
                        let leftBorder = -sizes.realZoom*(sizes.viewBox.x - vm.extraWidth);
                        let topBorder = -sizes.realZoom*(sizes.viewBox.y - vm.extraHeight);
                        let rightBorder =
                            -sizes.realZoom*(sizes.viewBox.x + vm.extraWidth) - clientRect.width + sizes.width;
                        let bottomBorder =
                            -sizes.realZoom*(sizes.viewBox.y + vm.extraHeight) - clientRect.height + sizes.height;
                        let customPan = {};
                        customPan.x = Math.min(leftBorder, Math.max(rightBorder, newPan.x));
                        customPan.y = Math.min(topBorder, Math.max(bottomBorder, newPan.y));
                        return customPan;
                    },
                    onZoom: function (e) {
                        let sizes = this.getSizes();
                        let svg = document.querySelector('.svg-pan-zoom_viewport');
                        if (!svg) {
                            return;
                        }
                        let clientRect = svg.getBoundingClientRect();
                        let leftBorder = -sizes.realZoom*(sizes.viewBox.x - vm.extraWidth);
                        let topBorder = -sizes.realZoom*(sizes.viewBox.y - vm.extraHeight);
                        let rightBorder =
                            -sizes.realZoom*(sizes.viewBox.x + vm.extraWidth) - clientRect.width + sizes.width;
                        let bottomBorder =
                            -sizes.realZoom*(sizes.viewBox.y + vm.extraHeight) - clientRect.height + sizes.height;
                        vm.isZoomInDisabled = e >= 2.4;
                        vm.isZoomOutDisabled = e <= 1.4001;
                        let pan = this.getPan();
                        let customPan = {};
                        customPan.x = Math.min(leftBorder, Math.max(rightBorder, pan.x));
                        customPan.y = Math.min(topBorder, Math.max(bottomBorder, pan.y));
                        this.pan(customPan);
                    }
                });
                setTimeout(() => {
                    this.resizeMap();
                }, 50);
            } else {
                this.map = null;
            }
        }
    }
}